@let point = data.point;
<onyx-modal
  variant="center"
  [size]="480"
  [showBottomBar]="false"
  (closeModal)="dialogRef.close()"
>
  <div heading class="modal-heading">
    <h3>
      {{ `${DictionaryCode.ORDER_POINT_TYPE}.${point.type}` | translate }}
    </h3>
    @if (point.address && 'poiName' in point.address) {
      <span class="f-muted">{{ point.address.poiName }}</span>
    }
  </div>

  <div class="container">
    <div class="summary">
      <onyx-data-widget [padding]="10">
        <onyx-icon name="good-filled" [size]="20"></onyx-icon>

        <p class="f-paragraph-m f-medium">
          @if (totalGoods) {
            {{ totalGoods.quantity }} {{ totalGoods.quantityUnit | translate }}
            {{ totalGoods.unit.names | onyxLanguage }}
          } @else {
            {{ 'labels.variousUnits' | translate }}
          }
        </p>
      </onyx-data-widget>

      <onyx-data-widget [padding]="10">
        <onyx-icon name="weight-filled" [size]="20"></onyx-icon>
        <p class="f-paragraph-m f-medium">{{ totalWeight | number }} kg</p>
      </onyx-data-widget>
    </div>

    @for (good of goods; track good.uuid) {
      <div class="good">
        <div class="heading">
          <onyx-icon
            [style.color]="good.color"
            name="good-filled"
            [size]="16"
          ></onyx-icon>

          <h6>
            {{ good.type ? (good.type.names | onyxLanguage) : good.typeName }}
          </h6>
        </div>

        <div class="details">
          <onyx-information-list>
            <onyx-information-row label="labels.unit">
              {{ good.unit.names | onyxLanguage }}
            </onyx-information-row>

            <onyx-information-row label="labels.totalWeight">
              {{ good.totalWeight | number }} kg
            </onyx-information-row>

            @if (good.size; as size) {
              <onyx-information-row label="labels.size">
                @if (size.type === GoodsSizeType.DIMENSIONS) {
                  {{ size | dimensions }} ·
                }

                {{ good | goodQuantity }}
              </onyx-information-row>
            }

            @if (good.referenceNumber; as referenceNumber) {
              <onyx-information-row label="labels.goodReferenceNumber">
                {{ referenceNumber }}
              </onyx-information-row>
            }

            @if (good.unitedNationsNumber; as unitedNationsNumber) {
              <onyx-information-row label="labels.unitedNations">
                {{ unitedNationsNumber }}
              </onyx-information-row>
            }

            @if (good.statisticalNumber; as statisticalNumber) {
              <onyx-information-row label="labels.statisticalNumber">
                {{ statisticalNumber }}
              </onyx-information-row>
            }
          </onyx-information-list>
        </div>
      </div>
    }
  </div>
</onyx-modal>
